import {
    Button,
    MenuItem,
} from '@chakra-ui/react';
import { ThemeTokens } from '@acp/core-ui';
import { useIsImpersonating } from '@acp/feature/auth';
import { AccessIssuesWizardMachineContext, AccessIssuesWizardProvider } from './machine/context';
import { AccessIssuesWizardModal } from './modal';

function ResolveButtonInner({ isMenuItem = false }: { isMenuItem?: boolean }) {
    const machine = AccessIssuesWizardMachineContext.useActorRef();
    const isImpersonating = useIsImpersonating();

    if (isMenuItem) {
        return (
            <MenuItem onClick={() => machine.send({ type: 'OPEN', enableDebugMode: isImpersonating })}>
                Resolve issue
            </MenuItem>
        );
    }

    return (
        <Button
            borderRightWidth={1}
            borderRightColor="secondary.900"
            borderColor={ThemeTokens.Defaults.borderColor}
            color="muted.700"
            bgColor="white"
            onClick={() => machine.send({ type: 'OPEN', enableDebugMode: isImpersonating })}
            colorScheme="charcoal"
            variant="outline"
            size="sm"
        >
            Resolve issue
        </Button>
    );
}

export function AccessIssueWizardResolveButton({
    propertyId,
    isMenuItem = false,
}: {
    propertyId: number;
    isMenuItem?: boolean;
}) {
    return (
        <AccessIssuesWizardProvider propertyId={propertyId}>
            <ResolveButtonInner isMenuItem={isMenuItem} />
            <AccessIssuesWizardModal />
        </AccessIssuesWizardProvider>
    );
}
